import FJAiVideoDubRight from '../view/FJAiVideoDubRight';
import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJAiVideoDubRightContainer = () => {
    useLocalStore();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const hasResult = useSelector(state => state.aiVideoDub.resultInfo && state.aiVideoDub.resultInfo.videoUrl !== '');

    return <FJAiVideoDubRight taskStatus={taskStatus} hasResult={hasResult} />;
};

export default FJAiVideoDubRightContainer;
